import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import api from 'api';
import { showMessage } from 'actions/index';

function RecipeSaveToMyRecipes() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { hash } = useParams();

    useEffect(() => {
        api('recipes/save-to-my-recipes/' + hash, { post: true, data: { hash } }).then(() => {
            dispatch(showMessage({ show: true, type: 'success', message: 'Recept byl uložen do Vašich receptů.' }));
            history.push('/recipe/me');
        });
    }, []);

    return null;
}

export default RecipeSaveToMyRecipes;
